import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import styled from '@emotion/styled';
import { SxProps } from '@mui/material';

const StyledRadio = styled(Radio)(({}) => ({
    color: 'black',
    '&.Mui-checked': {
        color: 'black',
    },
}));

interface RadioGroupTypes {
    value: string;
    label: string;
    defaultValue?: string;
}

interface RadioButtonProps {
    data: RadioGroupTypes[];
    alignItems: string;
    name?: string;
    setValue?: any;
    value?: string;
    disabled?: boolean;
    sx?: SxProps;
}

export default function RadioButtonsGroup({ data, alignItems, setValue, name, value, disabled, sx }: RadioButtonProps) {
    const handleChange = (event: any) => {
        const value = event.target.value;
        setValue && setValue(value);
    };

    return (
        <FormControl component="fieldset" disabled={disabled}>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={value || data[0]}
                name={name}
                onChange={handleChange}
                sx={{ alignItems: alignItems, ...sx }}
            >
                {data.map((radio) => (
                    <FormControlLabel key={radio.value} value={radio.value} control={<StyledRadio />} label={radio.label} />
                ))}
            </RadioGroup>
        </FormControl>
    );
}
